export const CART_UPDATE_EVENT = 'cartUpdate'
export const BILLING_INFO_UPDATE_EVENT = 'billingInfoUpdate'
export const OPEN_SIDE_DRAWER_EVENT = 'openSideDrawer'
export type OpenSideDrawerPayload = { content: HTMLElement }
export const CLOSE_SIDE_DRAWER_EVENT = 'closeSideDrawer'
